import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    // externalUUIDs resolved since page load, shared by the popups and the section (#42599) so resolving
    // in one place hides it in the others too.
    resolvedExternalUUIDs: [],
    // externalUUIDs currently being submitted by any of the three components, shared so a concurrent
    // click on the same item elsewhere is blocked while the request is in flight.
    inFlightExternalUUIDs: [],
};

const taxAgencyPendingApprovalsSlice = createSlice({
    name: "TaxAgencyPendingApprovals",
    initialState,
    reducers: {
        markPendingApprovalResolved(state, action) {
            state.resolvedExternalUUIDs.push(action.payload);
        },
        claimPendingApproval(state, action) {
            if (!state.inFlightExternalUUIDs.includes(action.payload)) {
                state.inFlightExternalUUIDs.push(action.payload);
            }
        },
        releasePendingApproval(state, action) {
            state.inFlightExternalUUIDs = state.inFlightExternalUUIDs.filter((uuid) => uuid !== action.payload);
        },
    },
});

export default taxAgencyPendingApprovalsSlice;
